/** Quote CSV correctly and keep untrusted spreadsheet cells as literal text. */
export function serializeCsv(rows: unknown[][]): string {
    return rows.map(row => row.map(value => {
        let text = value == null ? '' : String(value);
        // Spreadsheet applications may ignore leading whitespace before a formula.
        if (/^[\s\uFEFF]*[=+\-@]/.test(text) || /^[\t\r\n]/.test(text)) text = "'" + text;
        return `"${text.replace(/"/g, '""')}"`;
    }).join(',')).join('\r\n');
}

export function downloadCsv(rows: unknown[][], filename: string): void {
    const url = URL.createObjectURL(new Blob(['\uFEFF', serializeCsv(rows)], { type: 'text/csv;charset=utf-8;' }));
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    try {
        link.click();
    } finally {
        link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 0);
    }
}
